import { render } from "./TopUserPane.vue?vue&type=template&id=49ae38ad&scoped=true"
import script from "./TopUserPane.vue?vue&type=script&lang=js"
export * from "./TopUserPane.vue?vue&type=script&lang=js"

import "./TopUserPane.vue?vue&type=style&index=0&id=49ae38ad&scoped=true&lang=css"

import exportComponent from "/Users/beerebeerey/github-classroom/MUICCS/cs340prj-beersilver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ae38ad"]])

export default __exports__